import { render, staticRenderFns } from "./album.vue?vue&type=template&id=2a3b5576&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=2a3b5576&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3b5576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3b5576')) {
      api.createRecord('2a3b5576', component.options)
    } else {
      api.reload('2a3b5576', component.options)
    }
    module.hot.accept("./album.vue?vue&type=template&id=2a3b5576&scoped=true", function () {
      api.rerender('2a3b5576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/album.vue"
export default component.exports